import { toQueryParams } from '@/api/util';
import { get, post } from '@/api/v1';
import {
  ConversationHistoryDto,
  ConversationResponseDto,
  FindHistoryRequest,
  StartConversationRequest,
} from './api.types';

export const startConversation = (request: StartConversationRequest) =>
  post<ConversationResponseDto>(`conversation`, request);

export const continueConversation = (conversationId: string, query: string) =>
  post<ConversationResponseDto>(`conversation/${conversationId}`, {
    query,
  });

export const findConversations = (request: FindHistoryRequest) =>
  get<ConversationHistoryDto[]>(`conversation${toQueryParams({ ...request })}`);
